import { action, makeObservable, observable } from "mobx";
import AgentStore from "./agentStore";

class PlaygroundConfigStore {
    agentStore = null;
    
    llmModel = 'gpt-4'; 
    
    isLoading = false;
    error = null;
    
    availableAgentTypes = [
        { label: "AI", value: "ai" },        
    ];

    availableCategories = [
        { label: "Sales", value: "sales" },
        { label: "Inventory", value: "Inventory" },
        { label: "Service", value: "Service" },
        { label: "Operations", value: "Operations" },
        { label: "Telemetry", value: "Telemetry" },
        { label: "Analytics", value: "Analytics" },
        { label: "Finance", value: "Finance" },
        { label: "HR", value: "HR" },       
    ];

    availableLLMModels = [
    {
        label: 'Open AI',
        value: 'openai',
        models: [
        { label: 'Chat GPT 4o-mini', value: 'chat-gpt-4o-mini' },
        { label: 'Chat GPT 3.5 Turbo', value: 'chat-gpt-3.5-turbo' },
        { label: 'Chat GPT 4o', value: 'chat-gpt-4o' },
        ]
    },
    {
        label: 'Anthropic',
        value: 'anthropic',
        models: [
        { label: 'Claude 3 Opus', value: 'claude-3-opus' },
        ]
    },
    {
        label: 'Amazon',
        value: 'amazon',
        models: [
        { label: 'Titan Text G1', value: 'titan-text-g1' },
        ]
        },
    {
        label: 'Ollama',
        value: 'ollama',
        models: [
            { label: 'Llama 3.3', value: 'llama3.3' },
            { label: 'Llama 3.2', value: 'llama3.2' },
            ]
        },
    {
        label: 'Mistral AI',
        value: 'Mistral AI',
        models: [
            { label: 'Mistral Medium 3', value: 'mistral-medium-3' },
            { label: 'Magistral Medium', value: 'magistral-medium' },
        ]
        },
    {
        label: 'Forefront AI',
        value: 'Forefront AI',
        models: [
            { label: 'Phi‑2', value: 'phi-2' },
            { label: 'Phi‑2.5', value: 'phi-2.5' },
        ]
        },
    {
        label: 'Cohere',
        value: 'Cohere',
        models: [
            { label: 'Command A1', value: 'command-a1' },        
        ]
        },
    
    ];

    constructor(agentStore) {
        this.agentStore = agentStore;
        makeObservable(this, {
            agentStore: observable,
            llmModel: observable,
            isLoading: observable,
            error: observable,

            setLLMModel: action,
            setError: action
        });
    }

    setLLMModel = (model) => { this.llmModel = model; };
    setError = (error) => { this.error = error; };

  
}

export default PlaygroundConfigStore;